import { render } from "./json-builder-wrapper.vue?vue&type=template&id=4d369c5a&scoped=true"
import script from "./json-builder-wrapper.vue?vue&type=script&lang=js"
export * from "./json-builder-wrapper.vue?vue&type=script&lang=js"

import "./json-builder-wrapper.vue?vue&type=style&index=0&id=4d369c5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d369c5a"]])

export default __exports__